import axios from "axios";

const BASE_URL = process.env.VUE_APP_SERVER_URL + "api/project";

class ProjectService {
    async getById(idproject) {
        idproject = idproject.replace(/\D/g, '')
        if(idproject == "") {
            idproject = 0
        }
        let result = null;
        await axios.get(`${BASE_URL}/${idproject}/dashboard/getbyid`, {headers: {'Access-Control-Allow-Origin': '*',"Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With" }})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            });
        return result;
    }
    async checkPermission(page, idproject) {
        idproject = idproject.replace(/\D/g, '')
        if(idproject == "") {
            idproject = 0
        }
        let result = null;
        await axios.get(`${BASE_URL}/${idproject}/dashboard/permission?page=${page}`, {headers: {'Access-Control-Allow-Origin': '*',"Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With" }})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            });
        return result;
    }
    async getAll() {
        let result = null;
        await axios.get(`${BASE_URL}/getall`, {headers: {'Access-Control-Allow-Origin': '*',"Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With" }})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            });
        return result;
    }
    async getAllAvailable() {
        let result = null;
        await axios.get(`${BASE_URL}/getallavailable`, {headers: {'Access-Control-Allow-Origin': '*',"Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With" }})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            });
        return result;
    }
    async getConfigs() {
        let result = null;
        await axios.get(`${BASE_URL}/getconfigs`, {headers: {'Access-Control-Allow-Origin': '*',"Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With" }})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            });
        return result;
    }
    async getAllByMember(idmember) {
        let result = null;
        await axios.get(`${BASE_URL}/${idmember}/projects`, {headers: {'Access-Control-Allow-Origin': '*',"Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With" }})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            });
        return result;
    }


}

export default new ProjectService;